export default __webpack_public_path__ + "3cdaf882dd72c623e0f55fa2651912c4.svg";